import { render, staticRenderFns } from "./NormalWarningDialog.vue?vue&type=template&id=4361726c&scoped=true"
import script from "./NormalWarningDialog.vue?vue&type=script&lang=js"
export * from "./NormalWarningDialog.vue?vue&type=script&lang=js"
import style0 from "./NormalWarningDialog.vue?vue&type=style&index=0&id=4361726c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../_workspace/production-sync-20260815/repo/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4361726c",
  null
  
)

export default component.exports